var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNikereact = function SvgNikereact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#686868",
    fillRule: "evenodd",
    d: "M65.6 11 27.1 21.4c-.8.2-1.5.3-2.3.3-3 0-5.5-1.6-5.5-5 0-1.4.4-3 1.4-4.9-3.4 4-6.7 8.9-6.7 12.5 0 1.4.4 2.6 1.5 3.5a7.3 7.3 0 0 0 4.9 1.8c2.4 0 4.9-1 6.8-1.8 3.2-1.2 38.6-16.5 38.6-16.5.3-.2.3-.4-.2-.3Z",
    clipRule: "evenodd"
  })));
};
export default SvgNikereact;